import {
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  customers: [],
}

const CustomersList = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMERS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_CUSTOMERS_SUCCESS:
      state = {
        ...state,
        customers: action.payload.customers,
        loading: false,
        done: true,
      }
      break
    case GET_CUSTOMERS_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CustomersList
